var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FieldType, InfoGrouping, } from "@brushfire/types";
import { Well, Col, Form, Row, Icon, ExpandableSection, Alert, IconButton, HorizontalRule } from "@brushfire/ui";
import { useContext, useState } from "react";
import Constants from "../../../data/constants";
import Skeleton from "@material-ui/lab/Skeleton";
import WidgetSticky from "../../Helpers/WidgetSticky";
import { FormattedDate, FormattedTime, useIntl } from "react-intl";
import WidgetFieldset from "../../Helpers/WidgetFieldset";
import FormikContextListener from "../../Helpers/FormikContextListener";
import { isPossiblePhoneNumber } from "react-phone-number-input/input";
import { convertToFieldViews, getDefaultCountry, getDynamicFieldValidation, getInitialFieldValues, getRemoteFetchValues, getRemoteValidateRes, handleErrors, isVisible, } from "../../../data/helpers";
import * as Yup from "yup";
import BrushfireField from "@brushfire/ui/dist/Elements/Form/BrushfireField";
import { postEmailResend, putOrderAssociate, putOrder, putOrderDisassociate, getOrder, postResendOrderSignatures, } from "../../../data/api";
import useWidgetHistory from "../../../hooks/useWidgetHistory";
import { useDispatch, useSelector } from "react-redux";
import { AppFormContext } from "../../../App";
import { Link } from "react-router-dom";
import { setPageError } from "../../../store/AppState/actions";
import Number from "../../UI/Number";
var useTypedSelector = useSelector;
var MyOrder = function (_a) {
    var eventData = _a.eventData, order = _a.order, path = _a.path, kiosk = _a.kiosk, isMobile = _a.isMobile, setCurrentOrder = _a.setCurrentOrder, setSuccessMessage = _a.setSuccessMessage;
    var _b = __read(useState(false), 2), sendingEmail = _b[0], setSendingEmail = _b[1];
    var _c = __read(useState(false), 2), emailSent = _c[0], setEmailSent = _c[1];
    var _d = __read(useState(false), 2), emailError = _d[0], setEmailError = _d[1];
    var _e = __read(useState(false), 2), associating = _e[0], setAssociating = _e[1];
    var _f = __read(useState(false), 2), associatingError = _f[0], setAssociatingError = _f[1];
    var _g = __read(useState(false), 2), disassociatingError = _g[0], setDisassociatingError = _g[1];
    var _h = __read(useState(false), 2), orderAssociated = _h[0], setOrderAssociated = _h[1];
    var intl = useIntl();
    var history = useWidgetHistory();
    var dispatch = useDispatch();
    var formikContext = useContext(AppFormContext).formikContext;
    var customerAccount = useTypedSelector(function (store) { return store.accounts; }).customerAccount;
    if (!order) {
        return (_jsx(WidgetSticky, __assign({ className: "sticky-form", bottomOffset: 75, topOffset: 10, active: true }, { children: _jsxs(Row, { children: [_jsxs(Col, __assign({ xs: 9 }, { children: [_jsx(Skeleton, { variant: "rect", width: "20%", style: { height: "21px" } }), _jsx("br", {}), _jsx(Skeleton, { variant: "rect", width: "40%", style: { height: "13px" } }), _jsx("br", {}), _jsx(Skeleton, { variant: "rect", width: "35%", style: { height: "13px" } }), _jsx("br", {}), _jsx(Skeleton, { variant: "rect", width: "36px", style: { height: "15px", marginTop: 20 } }), _jsx("br", {}), _jsx(Skeleton, { variant: "rect", width: "100%", style: { height: "32px" } }), _jsx("br", {}), _jsx(Skeleton, { variant: "rect", width: "46px", style: { height: "15px", marginTop: 20 } }), _jsx("br", {}), _jsx(Skeleton, { variant: "rect", width: "100%", style: { height: "32px" } })] })), _jsxs(Col, __assign({ xs: 3 }, { children: [_jsx(Skeleton, { variant: "rect", width: "30%", style: { height: "21px" } }), _jsx("br", {}), _jsx(Skeleton, { variant: "rect", width: "100%", style: { height: "138px" } })] }))] }) })));
    }
    var fieldViews = convertToFieldViews(order.fields);
    var isFreeOrder = order.paymentMethod === "No Charge";
    var isPOSOrder = order.isPOS;
    var initialValues = {
        fields: getInitialFieldValues({}, fieldViews, eventData),
        firstName: order.firstName,
        lastName: order.lastName,
        street1: order.street1,
        street2: order.street2,
        city: order.city,
        region: order.region,
        country: order.country || eventData.country,
        postalCode: order.postal,
        email: order.email,
        phone: order.phone,
        isFree: isFreeOrder,
        isPOS: isPOSOrder,
    };
    var fieldShape = getDynamicFieldValidation(fieldViews);
    var formSchema = Yup.object().shape({
        fields: Yup.object().when("isFree", function (_a, schema) {
            var _b = __read(_a, 1), isFree = _b[0];
            return !isFree
                ? schema.shape(fieldShape).required()
                : schema.when("isPOS", function (_a, posSchema) {
                    var _b = __read(_a, 1), isPOS = _b[0];
                    return !isPOS ? posSchema.shape(fieldShape).required() : posSchema.shape(fieldShape).nullable();
                });
        }),
        firstName: Yup.string()
            .typeError("First Name is required")
            .required("First Name is required"),
        lastName: Yup.string()
            .typeError("Last Name is required")
            .required("Last Name is required"),
        email: Yup.string().when("isPOS", function (_a, schema) {
            var _b = __read(_a, 1), isPOS = _b[0];
            return isPOS
                ? schema
                    .email("Email is invalid")
                    .typeError("Email is required")
                    .nullable()
                : schema
                    .email("Email is invalid")
                    .typeError("Email is required")
                    .required("Email is required");
        }),
        phone: Yup.string().when("isFree", function (_a, schema) {
            var _b = __read(_a, 1), isFree = _b[0];
            return isFree
                ? schema
                    .nullable()
                    .test("valid", "Phone number is invalid", function (val) { return (val ? isPossiblePhoneNumber(val) : true); })
                : schema
                    .typeError("Phone is required")
                    .test("valid", "Phone number is invalid", function (val) { return (val ? isPossiblePhoneNumber(val) : true); })
                    .required("Phone is required");
        }),
        street1: Yup.string().when("isFree", function (_a, schema) {
            var _b = __read(_a, 1), isFree = _b[0];
            return isFree
                ? schema.nullable()
                : schema.when("isPOS", function (_a, posSchema) {
                    var _b = __read(_a, 1), isPOS = _b[0];
                    return isPOS
                        ? posSchema.nullable()
                        : posSchema.typeError("Address is required").required("Address is required");
                });
        }),
        city: Yup.string().when("isFree", function (_a, schema) {
            var _b = __read(_a, 1), isFree = _b[0];
            return isFree
                ? schema.nullable()
                : schema.when("isPOS", function (_a, posSchema) {
                    var _b = __read(_a, 1), isPOS = _b[0];
                    return isPOS
                        ? posSchema.nullable()
                        : posSchema.typeError("Address is required").required("City is required");
                });
        }),
        country: Yup.string().when("isFree", function (_a, schema) {
            var _b = __read(_a, 1), isFree = _b[0];
            return isFree
                ? schema.nullable()
                : schema.when("isPOS", function (_a, posSchema) {
                    var _b = __read(_a, 1), isPOS = _b[0];
                    return isPOS
                        ? posSchema.nullable()
                        : posSchema.typeError("Address is required").required("Region is required");
                });
        }),
        postalCode: Yup.string().when("isFree", function (_a, schema) {
            var _b = __read(_a, 1), isFree = _b[0];
            return isFree
                ? schema.nullable()
                : schema.when("isPOS", function (_a, posSchema) {
                    var _b = __read(_a, 1), isPOS = _b[0];
                    return isPOS
                        ? posSchema.nullable()
                        : posSchema.typeError("Address is required").required("Postal Code is required");
                });
        }),
        isFree: Yup.boolean().required(),
        isPOS: Yup.boolean().required(),
    });
    var getRemoteValidateLocal = function (fieldId, value, setResponse) {
        return getRemoteValidateRes(fieldId, value, setResponse, eventData.eventNumber);
    };
    var getRemoteFetchValuesLocal = function (fieldId, value, setRemoteData) {
        return getRemoteFetchValues(fieldId, value, setRemoteData, eventData.eventNumber);
    };
    var addressField = {
        id: "",
        label: "Address",
        type: FieldType[FieldType.Address],
        value: "",
        validationExpression: "",
        isRequired: true,
        notes: "",
        hasError: false,
        errorMessage: "",
        isDisabled: false,
        isSensitive: false,
        isIntegration: false,
        isAdmin: false,
        specialFieldId: "",
        specialFieldLabel: "",
        parentOptionId: "",
        parentFieldId: null,
        formObjectId: null,
        options: [],
        childFields: [
            {
                id: "street1",
                label: "Street 1",
                value: "",
                displayOrder: 0,
                specialFieldLabel: "Street1",
            },
            {
                id: "street2",
                label: "Street 2",
                value: "",
                displayOrder: 1,
                specialFieldLabel: "Street2",
            },
            {
                id: "city",
                label: "City",
                value: "",
                displayOrder: 2,
                specialFieldLabel: "City",
            },
            {
                id: "region",
                label: "Region",
                value: "",
                displayOrder: 3,
                specialFieldLabel: "Region",
            },
            {
                id: "postalCode",
                label: "Postal Code",
                value: "",
                displayOrder: 4,
                specialFieldLabel: "PostalCode",
            },
            {
                id: "country",
                label: "Country",
                value: "",
                displayOrder: 5,
                specialFieldLabel: "Country",
            },
        ],
        remoteUrl: "",
        parentOptionIsSelected: false,
        hasRelevantOutput: false,
        confirm: false,
    };
    var onSubmit = function (values, formikHelpers) {
        var _a;
        var cleanedValues = Object.assign({}, values.fields);
        setSuccessMessage(undefined);
        setEmailSent(false);
        setAssociatingError(false);
        setDisassociatingError(false);
        (_a = Object.keys(cleanedValues)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            var _a, _b, _c, _d;
            if (key === "isGift" || key === "recipientEmail" || key === "isPreRegistered" || key === "copyToAll") {
                delete cleanedValues[key];
            }
            else {
                if (Array.isArray(cleanedValues[key])) {
                    cleanedValues[key] = cleanedValues[key].filter(function (x) { return !!x; });
                    if (cleanedValues[key].some(function (x) { return !!x.price; })) {
                        var v = intl.formatNumberToParts(1000.0, {
                            style: "currency",
                            currency: (_a = eventData.currency) !== null && _a !== void 0 ? _a : "USD",
                        });
                        var symbol_1 = ((_b = v.find(function (x) { return x.type === "currency"; })) === null || _b === void 0 ? void 0 : _b.value) || "$";
                        var isCommaDecimal_1 = ((_c = v.find(function (x) { return x.type === "decimal"; })) === null || _c === void 0 ? void 0 : _c.value) === ",";
                        (_d = cleanedValues[key]) === null || _d === void 0 ? void 0 : _d.forEach(function (opt) {
                            var _a, _b;
                            if (isNaN(opt.price)) {
                                opt.price = opt.price
                                    ? opt.price === ""
                                        ? 0
                                        : isCommaDecimal_1
                                            ? parseFloat(((_a = opt.price) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, "").replace(",", ".").replace(symbol_1 || "$", "")) || "0.00")
                                            : parseFloat(((_b = opt.price) === null || _b === void 0 ? void 0 : _b.replace(/\s+/g, "").replace(symbol_1 || "$", "")) || "0.00")
                                    : 0;
                            }
                        });
                    }
                }
            }
        });
        var otherValues = Object.assign({}, values);
        delete otherValues.fields;
        var payload = __assign(__assign({}, otherValues), { fields: Object.keys(cleanedValues).map(function (key) { return ({ id: key, value: cleanedValues[key] }); }) });
        putOrder(order.id, payload)
            .then(function (_a) {
            var data = _a.data;
            setCurrentOrder(data);
            setSuccessMessage("Order Saved");
            formikHelpers.resetForm({ values: values });
        })
            .catch(function (err) {
            handleErrors(err, dispatch, formikContext);
        })
            .finally(function () {
            formikHelpers.setSubmitting(false);
        });
    };
    var resendEmail = function (event) {
        event.stopPropagation();
        event.preventDefault();
        setSendingEmail(true);
        setEmailSent(false);
        setEmailError(false);
        postEmailResend(order.id)
            .then(function (_a) {
            var data = _a.data;
            if (data) {
                setEmailSent(true);
            }
            else {
                setEmailError(true);
            }
        })
            .finally(function () {
            setSendingEmail(false);
        });
    };
    var associateOrder = function (event) {
        event.stopPropagation();
        event.preventDefault();
        setAssociating(true);
        putOrderAssociate(order.id)
            .then(function (_a) {
            var data = _a.data;
            if (data) {
                setOrderAssociated(true);
                getOrder(order.id).then(function (_a) {
                    var data = _a.data;
                    if (data.eventNumber.toString() !== eventData.eventNumber.toString()) {
                        dispatch(setPageError({ error: "This order doesn't belong to this event", status: 400 }));
                    }
                    setCurrentOrder(data);
                });
            }
            else {
                setAssociatingError(true);
            }
        })
            .finally(function () {
            setAssociating(false);
        });
    };
    var disassociateOrder = function (event) {
        event.stopPropagation();
        event.preventDefault();
        setAssociating(true);
        //Remove an order from your account
        putOrderDisassociate(order.id)
            .then(function (_a) {
            var data = _a.data;
            if (data) {
                setOrderAssociated(false);
                getOrder(order.id).then(function (_a) {
                    var data = _a.data;
                    if (data.eventNumber.toString() !== eventData.eventNumber.toString()) {
                        dispatch(setPageError({ error: "This order doesn't belong to this event", status: 400 }));
                    }
                    setCurrentOrder(data);
                });
            }
            else {
                setDisassociatingError(true);
            }
        })
            .catch(function () {
            setDisassociatingError(true);
        })
            .finally(function () {
            setAssociating(false);
        });
    };
    return (_jsxs(Row, { children: [_jsxs(Col, __assign({ xs: "12" }, { children: [_jsx(ExpandableSection, __assign({ expand: emailError, transitionTime: 0.25 }, { children: _jsx("div", __assign({ className: "inline-error ".concat(emailError ? "active" : "") }, { children: _jsxs(Alert, __assign({ purpose: "danger" }, { children: [_jsx(IconButton, { icon: "times", classes: "f-right", ariaLabel: "Close Error", onClick: function () {
                                            setEmailError(false);
                                        } }), _jsx("div", __assign({ className: "my-1" }, { children: "Your confirmation email could not be resent" }))] })) })) })), _jsx(ExpandableSection, __assign({ expand: emailSent, transitionTime: 0.25 }, { children: _jsx("div", __assign({ className: "inline-success ".concat(emailSent ? "active" : "") }, { children: _jsxs(Alert, __assign({ purpose: "success" }, { children: [_jsx(IconButton, { icon: "times", classes: "f-right", ariaLabel: "Close Message", onClick: function () {
                                            setEmailSent(false);
                                        } }), _jsx("div", __assign({ className: "my-1" }, { children: "Your confirmation email was successfully sent." }))] })) })) })), _jsx(ExpandableSection, __assign({ expand: associatingError, transitionTime: 0.25 }, { children: _jsx("div", __assign({ className: "inline-error ".concat(associatingError ? "active" : "") }, { children: _jsxs(Alert, __assign({ purpose: "danger" }, { children: [_jsx(IconButton, { icon: "times", classes: "f-right", ariaLabel: "Close Error", onClick: function () {
                                            setAssociatingError(false);
                                        } }), _jsx("div", __assign({ className: "my-1" }, { children: "This order could not be associated with your account" }))] })) })) })), _jsx(ExpandableSection, __assign({ expand: disassociatingError, transitionTime: 0.25 }, { children: _jsx("div", __assign({ className: "inline-error ".concat(disassociatingError ? "active" : "") }, { children: _jsxs(Alert, __assign({ purpose: "danger" }, { children: [_jsx(IconButton, { icon: "times", classes: "f-right", ariaLabel: "Close Error", onClick: function () {
                                            setDisassociatingError(false);
                                        } }), _jsx("div", __assign({ className: "my-1" }, { children: "This order could not be disassociated with your account" }))] })) })) }))] })), _jsx(Col, __assign({ md: 9 }, { children: _jsx(Form, __assign({ initialValues: initialValues, validationSchema: formSchema, onSubmit: onSubmit, formikBagProps: {
                        submitButtonLabel: "Update",
                    }, autoComplete: kiosk ? "new-off" : "on", useUnsavedPrompt: false }, { children: function (_a) {
                        var formikContext = _a.formikContext;
                        return (_jsx(WidgetFieldset, { children: _jsxs("div", __assign({ className: "pos-relative" }, { children: [_jsx(FormikContextListener, { currentPath: path, path: Constants.Routes.myOrder, formikContext: formikContext, active: true, initialValues: initialValues, focusDelay: 500 }), _jsxs("div", { children: [_jsx(Row, { children: _jsxs(Col, __assign({ xs: 12 }, { children: [!!order.total && (_jsx(_Fragment, { children: _jsx("h3", __assign({ className: "bold" }, { children: order.externalInvoiceId ? (_jsxs(_Fragment, { children: [_jsx(Number, { value: order.total, style: "currency", currency: eventData === null || eventData === void 0 ? void 0 : eventData.currency }), _jsxs("a", __assign({ className: "ml-1 h6 bold unstyled-link", href: order.externalInvoiceLink, target: "_blank" }, { children: [order.paymentIcon && (_jsx("i", { className: "".concat(order.paymentIcon, " payment-method-icon"), title: order.paymentMethod })), " ", order.paymentMethod, " ", order.paymentNumber, !order.paidInFull ? (_jsxs("span", __assign({ className: "ml-1 h6 bold error" }, { children: [_jsx("i", { className: "fa fa-circle-exclamation", "aria-hidden": "true" }), " ", "Balance Due"] }))) : (_jsxs("span", __assign({ className: "ml-1 h6 bold success" }, { children: [_jsx("i", { className: "fa fa-circle-check", "aria-hidden": "true" }), " ", "Paid in Full"] })))] }))] })) : (_jsxs(_Fragment, { children: [_jsx(Number, { value: order.total, style: "currency", currency: eventData === null || eventData === void 0 ? void 0 : eventData.currency }), order.paymentIcon && (_jsxs(_Fragment, { children: [_jsx("i", { className: "".concat(order.paymentIcon, " payment-method-icon"), title: order.paymentMethod }), " "] })), _jsxs("span", __assign({ className: "ml-1 h6 bold" }, { children: [order.paymentMethod, " ", order.paymentNumber] })), order.paidInFull &&
                                                                            order.paymentMethodInfoGrouping ===
                                                                                InfoGrouping.CheckPO ? (order.paidInFull ? (_jsxs("span", __assign({ className: "ml-1 h6 bold success" }, { children: [_jsx("i", { className: "fa fa-circle-check", "aria-hidden": "true" }), " ", "Paid in Full"] }))) : (_jsxs("span", __assign({ className: "ml-1 h6 bold error" }, { children: [_jsx("i", { className: "fa fa-circle-exclamation", "aria-hidden": "true" }), " ", "Balance Due"] })))) : null] })) })) })), _jsx("h5", __assign({ className: "bold" }, { children: order.summary })), _jsxs("small", __assign({ className: "medium" }, { children: [_jsx(FormattedDate, { value: order.orderedAtLocal, year: "numeric", month: "long", day: "numeric", weekday: "long" }), " ", _jsx(FormattedTime, { value: order.orderedAtLocal, hour12: true })] })), order.customerAccountNumber && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsxs("small", { children: ["Associated with customer #", order.customerAccountNumber] })] })), isMobile && (_jsx("div", __assign({ className: "m-top" }, { children: _jsx(Actions, { eventData: eventData, order: order, resendEmail: resendEmail, sendingEmail: sendingEmail, associateOrder: associateOrder, disassociateOrder: disassociateOrder, orderAssociated: orderAssociated, associating: associating, customerAccount: customerAccount }) })))] })) }), _jsx(Row, __assign({ className: "m-top" }, { children: _jsxs(Col, __assign({ md: 12 }, { children: [_jsx(Form.Input.NameInput, { firstNameName: "firstName", lastNameName: "lastName", isRequired: true, autoComplete: !kiosk }), _jsxs(Row, { children: [_jsx(Col, __assign({ xs: 6 }, { children: _jsx(Form.Field, { component: Form.Input.Phone, name: "phone", id: "phone", label: "Phone", autoComplete: !kiosk, isFieldRequired: !isFreeOrder && !isPOSOrder && true }) })), _jsx(Col, __assign({ xs: 6 }, { children: _jsx(Form.Field, { name: "email", id: "email", label: "Email", type: "email", autoComplete: !kiosk, isFieldRequired: !isPOSOrder }) }))] }), !isFreeOrder && !isPOSOrder && (_jsx(BrushfireField, { id: "".concat(addressField.id), name: "".concat(addressField.id), fieldItem: addressField, currency: eventData.currency, autoComplete: !kiosk, defaultCountry: getDefaultCountry(eventData), intl: intl }))] })) }))] }), fieldViews.map(function (field, index) {
                                        var visible = isVisible(field, formikContext.values.fields, fieldViews);
                                        if (visible) {
                                            return (_jsx(BrushfireField, { id: "".concat(field.id), name: "".concat(field.id), fieldItem: field, currency: eventData.currency, remoteValidate: getRemoteValidateLocal, remoteFetch: getRemoteFetchValuesLocal, autoComplete: !kiosk, prefix: "fields.", defaultCountry: getDefaultCountry(eventData), intl: intl }, field.id || index.toString()));
                                        }
                                    })] })) }));
                    } })) })), !isMobile && (_jsx(Col, __assign({ md: 3 }, { children: _jsx(Actions, { eventData: eventData, order: order, resendEmail: resendEmail, sendingEmail: sendingEmail, associateOrder: associateOrder, disassociateOrder: disassociateOrder, orderAssociated: orderAssociated, associating: associating, customerAccount: customerAccount }) })))] }));
};
var Actions = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var eventData = _a.eventData, order = _a.order, resendEmail = _a.resendEmail, sendingEmail = _a.sendingEmail, associateOrder = _a.associateOrder, disassociateOrder = _a.disassociateOrder, associating = _a.associating, orderAssociated = _a.orderAssociated, customerAccount = _a.customerAccount;
    var _h = __read(useState(false), 2), signaturesSending = _h[0], setSignaturesSending = _h[1];
    var _j = __read(useState(false), 2), signaturesSent = _j[0], setSignaturesSent = _j[1];
    var _k = __read(useState(false), 2), signaturesError = _k[0], setSignaturesError = _k[1];
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "d-flex justify-space-between align-center" }, { children: _jsx("h6", __assign({ className: "semi-bold" }, { children: "Actions" })) })), _jsxs(Well, __assign({ className: "well-outline well-sidebar", contentClassName: "d-flex flex-column details-gap" }, { children: [_jsxs("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN).concat(Constants.Routes.portalOrderTickets
                            .replace(":clientKey", eventData.clientKey)
                            .replace(":urlKey", eventData.urlKey)
                            .replace(":orderId", order.id)
                            .replace(":eventNumber", eventData.eventNumber.toString())
                            .replace(Constants.Regex.guid, "")), tabIndex: 0, className: "unstyled-link details-sidebar-item", target: "_blank", rel: "noopener noreferrer" }, { children: [_jsx(Icon, { icon: "ticket", classes: "fa-fw" }), _jsx("span", { children: "View Tickets" })] })), _jsxs(Link, __assign({ to: Constants.Routes.myOrderAttendees
                            .replace(":clientKey", eventData.clientKey)
                            .replace(":urlKey", eventData.urlKey)
                            .replace(":orderId", order.id)
                            .replace(":eventNumber", eventData.eventNumber.toString())
                            .replace(Constants.Regex.guid, ""), tabIndex: 0, className: "unstyled-link details-sidebar-item" }, { children: [_jsx(Icon, { icon: "user", classes: "fa-fw" }), _jsx("span", { children: "Manage Attendees" })] })), _jsxs(Link, __assign({ className: "unstyled-link details-sidebar-item", to: "".concat((eventData.verbiage === "Tickets" ? Constants.Routes.tickets : Constants.Routes.register)
                            .replace(":clientKey", (_b = eventData === null || eventData === void 0 ? void 0 : eventData.clientKey) !== null && _b !== void 0 ? _b : "")
                            .replace(":urlKey", (_c = eventData === null || eventData === void 0 ? void 0 : eventData.urlKey) !== null && _c !== void 0 ? _c : "")
                            .replace(":eventNumber", ((_d = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _d !== void 0 ? _d : 0).toString()), "?originalOrderId=").concat(order.id) }, { children: [_jsx(Icon, { icon: "users", classes: "fa-fw" }), _jsx("span", { children: "Add More Attendees" })] })), eventData.addOns.length > 0 && (_jsxs(Link, __assign({ className: "unstyled-link details-sidebar-item", to: "".concat(Constants.Routes.addons
                            .replace(":clientKey", (_e = eventData === null || eventData === void 0 ? void 0 : eventData.clientKey) !== null && _e !== void 0 ? _e : "")
                            .replace(":urlKey", (_f = eventData === null || eventData === void 0 ? void 0 : eventData.urlKey) !== null && _f !== void 0 ? _f : "")
                            .replace(":eventNumber", ((_g = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber) !== null && _g !== void 0 ? _g : 0).toString()), "?originalOrderId=").concat(order.id) }, { children: [_jsx(Icon, { icon: "box", classes: "fa-fw" }), _jsx("span", { children: "Add More Add-ons" })] }))), order.email && (_jsxs("a", __assign({ href: "#", onClick: resendEmail, className: "unstyled-link details-sidebar-item" }, { children: [sendingEmail && _jsx(Icon, { icon: "spinner-third", classes: "fa-spin fa-fw" }), !sendingEmail && _jsx(Icon, { icon: "envelope", classes: "fa-fw" }), _jsx("span", { children: "Resend Confirmation Email" })] }))), !order.customerAccountNumber && !!(customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.email) && (_jsxs("a", __assign({ href: "#", onClick: associateOrder, className: "unstyled-link details-sidebar-item" }, { children: [associating && _jsx(Icon, { icon: "spinner-third", classes: "fa-spin fa-fw" }), !associating && _jsx(Icon, { icon: "link", classes: "fa-fw" }), _jsx("span", { children: "Associate with My Account" })] }))), order.customerAccountNumber && (customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.accountNumber) === order.customerAccountNumber && (_jsxs("a", __assign({ href: "#", onClick: disassociateOrder, className: "unstyled-link details-sidebar-item" }, { children: [associating && _jsx(Icon, { icon: "spinner-third", classes: "fa-spin fa-fw" }), !associating && _jsx(Icon, { icon: "link-slash", classes: "fa-fw" }), _jsx("span", { children: "Disassociate with My Account" })] }))), _jsxs("a", __assign({ href: "https://".concat(process.env.REACT_APP_DOMAIN).concat(Constants.Routes.myOrderReceipt
                            .replace(":clientKey", eventData.clientKey)
                            .replace(":urlKey", eventData.urlKey)
                            .replace(":orderId", order.id)
                            .replace(":eventNumber", eventData.eventNumber.toString())
                            .replace(Constants.Regex.guid, "")), tabIndex: 0, target: "_blank", rel: "noopener noreferrer", className: "unstyled-link details-sidebar-item" }, { children: [_jsx(Icon, { icon: "receipt", classes: "fa-fw" }), _jsx("span", { children: "Print Receipt" })] })), order.hasPendingSignatures && (_jsx("a", __assign({ href: "#", tabIndex: 0, className: "unstyled-link details-sidebar-item ".concat(signaturesSending ? "disabled" : ""), rel: "noopener noreferrer", onClick: function (evt) {
                            if (!signaturesSending) {
                                evt.stopPropagation();
                                evt.preventDefault();
                                setSignaturesSending(true);
                                postResendOrderSignatures(order.id)
                                    .then(function () {
                                    setSignaturesSent(true);
                                    setTimeout(function () {
                                        setSignaturesSent(false);
                                    }, 5000);
                                })
                                    .catch(function () {
                                    setSignaturesError(true);
                                    setTimeout(function () {
                                        setSignaturesError(false);
                                    }, 5000);
                                })
                                    .finally(function () {
                                    setSignaturesSending(false);
                                });
                            }
                        } }, { children: signaturesSent ? (_jsxs(_Fragment, { children: [_jsx(Icon, { icon: "check", classes: "m-right fa-fw" }), _jsx("span", { children: "Signatures Sent!" })] })) : (_jsx(_Fragment, { children: signaturesError ? (_jsxs(_Fragment, { children: [_jsx(Icon, { icon: "triangle-exclamation", classes: "m-right fa-fw" }), _jsx("span", { children: "Something went wrong while resending your signature" })] })) : (_jsxs(_Fragment, { children: [signaturesSending ? (_jsx(Icon, { icon: "spinner-third", classes: "fa-spin m-right fa-fw" })) : (_jsx(Icon, { icon: "pen-field", classes: "m-right fa-fw" })), _jsx("span", { children: "Resend Signatures" })] })) })) }))), order.externalInvoiceId && (_jsxs(_Fragment, { children: [_jsx(HorizontalRule, { className: "pt-3" }), _jsxs("a", __assign({ href: order.externalInvoiceLink, tabIndex: 0, className: "unstyled-link details-sidebar-item", target: "_blank", rel: "noopener noreferrer" }, { children: [_jsx(Icon, { icon: "external-link", classes: "fa-fw" }), _jsx("span", { children: order.paidInFull ? "View Square Invoice" : "Pay Square Invoice" })] }))] }))] }))] }));
};
export default MyOrder;
